(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // AR flexible mega menu. Main menu remains the source for mobile navigation.
  (() => {
    if (window.arFlexibleMenuReady) return;
    window.arFlexibleMenuReady = true;
    const desktop = window.matchMedia('(min-width: 990px)');
    const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const controllers = new Map();

    const hosts = () => document.querySelectorAll('header-menu.ar-menu-host');

    function syncOpenState() {
      const anyOpen = Array.from(hosts()).some(host => host.querySelector('details')?.open);
      document.body.classList.toggle('ar-mega-menu-open', anyOpen);
    }

    function setOpen(host, open) {
      const details = host.querySelector('details');
      if (!details) return;
      const summary = details.querySelector('summary');
      const panel = details.querySelector('.ar-menu-panel');
      if (open) {
        hosts().forEach(other => {
          if (other !== host) setOpen(other, false);
        });
        const bottom = host.closest('.header-wrapper')?.getBoundingClientRect().bottom;
        if (bottom !== undefined) panel.style.setProperty('--ar-menu-top', `${Math.max(0, bottom)}px`);
      }
      details.open = open;
      summary.setAttribute('aria-expanded', String(open));
      syncOpenState();
      if (open) requestAnimationFrame(() => layoutCards(host));
    }

    function layoutCards(root) {
      root.querySelectorAll('.ar-menu__cards').forEach(grid => {
        const width = grid.clientWidth;
        if (!width) return;
        const gap = parseFloat(getComputedStyle(grid).columnGap) || 24;
        const maximum = Number(grid.dataset.maxColumns) || 5;
        const available = Math.max(1, Math.floor((width + gap) / (180 + gap)));
        const columns = Math.min(maximum, available, grid.children.length || 1);
        grid.style.setProperty('--ar-card-cols', columns);
      });
    }

    function setup(root = document) {
      root.querySelectorAll('header-menu.ar-menu-host').forEach(host => {
        if (controllers.has(host)) return;
        const controller = new AbortController();
        const options = { signal: controller.signal };
        const details = host.querySelector('details');
        const summary = details.querySelector('summary');
        const panel = details.querySelector('.ar-menu-panel');
        let timer;
        const cancel = () => clearTimeout(timer);
        const enabled = () => desktop.matches && hover.matches && host.dataset.arHover === 'true';
        const on = (event, handler) => host.addEventListener(event, handler, options);

        // The earlier AR hover script skips hosts that already have this marker.
        host.dataset.arHoverReady = 'true';
        on('pointerenter', event => {
          if (!enabled() || event.pointerType !== 'mouse') return;
          cancel();
          setOpen(host, true);
        });
        on('pointerleave', event => {
          if (!enabled() || event.pointerType !== 'mouse') return;
          cancel();
          timer = setTimeout(() => {
            if (!host.matches(':hover') && !panel.contains(document.activeElement) && !host.hasAttribute('data-ar-editor-open')) {
              setOpen(host, false);
            }
          }, 60);
        });
        on('keydown', event => {
          if (event.key !== 'Escape' || !details.open) return;
          cancel();
          host.removeAttribute('data-ar-editor-open');
          setOpen(host, false);
          summary.focus({ preventScroll: true });
          event.preventDefault();
          event.stopPropagation();
        });
        summary.addEventListener('click', () => {
          cancel();
          if (!details.open) {
            hosts().forEach(other => { if (other !== host) setOpen(other, false); });
            const bottom = host.closest('.header-wrapper')?.getBoundingClientRect().bottom;
            if (bottom !== undefined) panel.style.setProperty('--ar-menu-top', `${Math.max(0, bottom)}px`);
          }
        }, options);
        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(details.open));
          syncOpenState();
          if (details.open) layoutCards(host);
        }, options);
        let observer;
        if ('ResizeObserver' in window) {
          observer = new ResizeObserver(() => layoutCards(host));
          host.querySelectorAll('.ar-menu__cards').forEach(grid => observer.observe(grid));
        }
        controllers.set(host, () => { cancel(); observer?.disconnect(); controller.abort(); });
        layoutCards(host);
      });
    }

    document.addEventListener('pointerdown', event => {
      hosts().forEach(host => {
        if (!host.contains(event.target) && !host.hasAttribute('data-ar-editor-open')) setOpen(host, false);
      });
    });
    desktop.addEventListener('change', () => hosts().forEach(host => setOpen(host, false)));
    document.addEventListener('shopify:section:load', event => setup(event.target));
    document.addEventListener('shopify:section:unload', event => {
      controllers.forEach((cleanup, host) => {
        if (event.target.contains(host)) { cleanup(); controllers.delete(host); }
      });
    });
    document.addEventListener('shopify:block:select', event => {
      if (!desktop.matches) return;
      const id = event.detail?.blockId;
      const block = [...document.querySelectorAll('[data-ar-block-id]')].find(item => item.dataset.arBlockId === id);
      const host = block?.closest('header-menu.ar-menu-host');
      if (host) { host.setAttribute('data-ar-editor-open', ''); setOpen(host, true); }
    });
    document.addEventListener('shopify:block:deselect', () => {
      hosts().forEach(host => {
        if (host.hasAttribute('data-ar-editor-open')) {
          host.removeAttribute('data-ar-editor-open');
          if (!host.matches(':hover') && !host.contains(document.activeElement)) setOpen(host, false);
        }
      });
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), { once: true });
    else setup();
  })();


  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
